// extracted by mini-css-extract-plugin
export default {"Container":"Subtitle_Container__DASXo"};